import * as constants from "../constants";

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {

    case constants.LOAD_USER_INFO:
      console.log(state,"----------");
      return Object.assign({}, state, action.data);

    case constants.USER_LOGOUT:
      return initialState;

    default:
      return state;
  }
}
